import React from 'react';
import ReactDiffViewer from 'react-diff-viewer';

const AuditLogDiffViewer = (props) => {
    const { auditLog } = props
    const currentData = auditLog.find(log => log.version === 'CURRENT');
    const previousData = auditLog.find(log => log.version === 'PREVIOUS');
    const currentJson = currentData?.changeJson;
    const previousJson = previousData?.changeJson;

    const oldJsonString = JSON.stringify(previousJson, null, 2);
    const newJsonString = JSON.stringify(currentJson, null, 2);

    return (
        <ReactDiffViewer
            styles={{ titleBlock: { textAlign: 'center', fontWeight: 'bold' } }}
            leftTitle={`${previousData?.version ?? 'Previous'}: ${previousData?.operation ?? 'No Data'}`}
            rightTitle={`${currentData?.version}: ${currentData?.operation}`}
            oldValue={oldJsonString}
            newValue={newJsonString}
            splitView={true}
            showDiffOnly={false}
        />
    );
};

export default AuditLogDiffViewer;